import { inject, Injectable } from '@angular/core'
import { Action, select, Store } from '@ngrx/store'

import * as TeamsSelectors from './teams.selectors'

@Injectable({
  providedIn: 'root',
})
export class TeamsFacade {
  private readonly store = inject(Store)

  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = this.store.pipe(select(TeamsSelectors.selectTeamsLoaded))
  allTeams$ = this.store.pipe(select(TeamsSelectors.selectAllTeams))
  selectedTeam$ = this.store.pipe(select(TeamsSelectors.selectedTeam))
  dataView$ = this.store.pipe(select(TeamsSelectors.getDataView))
  searchHistory$ = this.store.pipe(select(TeamsSelectors.selectSearchHistory))
  count$ = this.store.pipe(select(TeamsSelectors.selectCount))
  editCreateLoaded$ = this.store.pipe(select(TeamsSelectors.selectEditCreateLoaded))

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
